<!--
  组件说明：分类树组件，根据传入值的类型判断返回结果，分别有：分类对象、分类编号、分类编号集合
  调用示范：
  <el-dialog title="选择分类" :visible.sync="showDialog" width="30%" center>
    <classifyTree :value.sync="value" type="questions" :visible.sync="showDialog"></classifyTree>
  </el-dialog>
-->
<template>
  <div>
    <div ref="treectn01" :style="`height: ${treeHeight}; overflow: auto;`">
      <el-tree
        :data="data"
        :show-checkbox="Array.isArray(value)"
        default-expand-all
        node-key="flbh"
        ref="tree"
        highlight-current
        :default-checked-keys="flbhs"
        :props="defaultProps"
        check-strictly
        @node-click="handleNodeClick"
        :expand-on-click-node="false">
      </el-tree>
    </div>
    <!-- <div v-show="Array.isArray(value)" style="margin-bottom: -10px;">
      <el-divider></el-divider>
    </div> -->
    <br>
    <div v-show="Array.isArray(value)" class="buttons" style="text-align:center;">
      <el-button type="primary" @click="getCheckedKeys">确定</el-button>
      <el-button type="primary" @click="resetChecked">清空</el-button>
    </div>
  </div>
</template>
<script>
import { getClassifyList as examClassify } from '@/api/exam'
import { getClassifyList as examPaperClassify } from '@/api/examPaper'
import { getClassifyList as questionsClassify } from '@/api/questions'
export default {
  data () {
    return {
      data: [],
      defaultProps: {
        children: 'children',
        label: 'flmc'
      },
      flbhs: this.value instanceof Array ? this.value : []
    }
  },
  props: {
    type: String,
    value: {
      type: [Object, Number, Array]
    },
    visible: Boolean,
    treeHeight: {
      type: String,
      default: () => { return '400px' }
    }
  },
  watch: {
    value (val) {
      if (val instanceof Array) {
        setTimeout(() => {
          this.flbhs = val
          this.$refs.tree.setCheckedKeys(this.flbhs)
        }, 100)
      }
    }
  },
  methods: {
    // 选择某个部门
    handleNodeClick (data) {
      this.$emit('click')
      // console.log(data)
      if (!this.value || this.value.constructor === Number) {
        this.$emit('update:value', data.flbh)
        this.$emit('update:visible', false)
      } else if (this.value.constructor === Object && !Array.isArray(this.value)) {
        this.$emit('update:value', data)
        this.$emit('update:visible', false)
      }
    },
    // 确定
    getCheckedKeys () {
      // console.log(this.$refs.tree.getCheckedKeys())
      if (this.value instanceof Array) {
        this.$emit('update:value', this.$refs.tree.getCheckedKeys())
        this.$emit('update:visible', false)
      }
    },
    // 重置
    resetChecked () {
      this.$emit('update:value', [])
      this.$refs.tree.setCheckedKeys([])
    },
    // 将数据转成成树形结构
    parseTree (list) {
      const temp = {}
      const tree = {}
      // 数组转 键值对
      list.forEach(flObj => {
        temp[flObj.flbh] = flObj
      })
      for (const flbh in temp) {
        const fl = temp[flbh]
        const sjflObj = temp[fl.sjfl]
        if (sjflObj) {
          if (!sjflObj.children) {
            sjflObj.children = []
          }
          sjflObj.children.push(fl)
        } else {
          tree[flbh] = fl
        }
      }
      this.data = Object.keys(tree).map(key => tree[key])
    },
    examClassify () {
      examClassify(null).then(res => {
        this.$http.callback(res, () => {
          // 生成分类树
          this.parseTree(res.data)
        })
      })
    },
    examPaperClassify () {
      examPaperClassify(null).then(res => {
        this.$http.callback(res, () => {
          // 生成分类树
          this.parseTree(res.data)
        })
      })
    },
    questionsClassify () {
      questionsClassify(null).then(res => {
        this.$http.callback(res, () => {
          // 生成分类树
          this.parseTree(res.data)
        })
      })
    },
    init () {
      const type = this.type
      switch (type) {
        case 'exam':
          this.examClassify()
          break
        case 'examPaper':
          this.examPaperClassify()
          break
        case 'questions':
          this.questionsClassify()
          break
        default:
          this.data = []
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
